import * as actionTypes from "../../constants/actionTypes";
import { getProvider, getProviderIds, getProviders } from "../../api/provider";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidateProviders = () => {
  return {
    type: actionTypes.INVALIDATE_PROVIDERS_DATA
  };
};

const loadProvider = (clientConfig, providerId) => {
  return {
    type: actionTypes.LOAD_PROVIDER_DATA,
    promise: getProvider(clientConfig, providerId)
  };
};

const loadProviderPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PROVIDER_PROPOSITION_IDS_DATA,
    promise: getProviderIds(clientConfig, OFFER_TYPES.proposition, dataStatus)
  };
};

const loadProviderSimOnlyIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PROVIDER_SIM_ONLY_IDS_DATA,
    promise: getProviderIds(clientConfig, OFFER_TYPES.simOnly, dataStatus)
  };
};

const loadProviders = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PROVIDERS_DATA,
    promise: getProviders(clientConfig, dataStatus)
  };
};

export {
  invalidateProviders,
  loadProvider,
  loadProviderPropositionIds,
  loadProviderSimOnlyIds,
  loadProviders
};
